import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from "react-redux";
import store from '../src/store'
ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
    {/* we should wrapp the route around the app */}
    <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);

